import { Box, Grid } from "@mui/material";
import InfoBox from "./InfoBox";
import moment from "moment";
import { useAppDispatch, useAppSelecter } from "../../../hooks/storeHooks";
import { RootState } from "../../../store/store";
import React from "react";
import { fetchInternalUsers } from "../../../store/slices/InternalUsers/InternalUserSlice";

function CardFooter({
  internal_remark,
  created_at,
  created_by_id,
  modified_at,
  modified_by_id,
}: {
  internal_remark: string;
  created_at: string;
  created_by_id: string;
  modified_at?: string;
  modified_by_id?: string;
}) {
  const dispatch = useAppDispatch();
  const { users } = useAppSelecter(
    (state: RootState) => state.internalUserSlice
  );

  React.useEffect(() => {
    if (users.length === 0) {
      dispatch(fetchInternalUsers());
    }
  }, [dispatch, users.length]);
  console.log(users, "usersusers");
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Box sx={{ width: "100%" }}>
          {" "}
          <InfoBox
            title="Internal Details"
            lines={[`Internal Remark: ${internal_remark ?? "-"}`]}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <InfoBox
          title="Creation Details"
          lines={[
            `Created: ${moment(created_at).format("Do MMM YYYY, hh:mm A")} by ${
              created_by_id
                ? users.find((user) => user.id === created_by_id)?.user_data
                    .full_name ?? ""
                : created_by_id
            }`,
            modified_at
              ? `Modified: ${moment(modified_at).format(
                  "Do MMM YYYY, hh:mm A"
                )} by ${ modified_by_id
                ? users.find((user) => user.id === modified_by_id)?.user_data
                    .full_name ?? ""
                : modified_by_id }`
              : "",
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default CardFooter;
